module.exports = __webpack_public_path__ + "img/Send.871997d2.png";